/*
 * File: /src/router/routes/company.js
 * Created Date: Sunday September 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 15th September 2019 2:29:21 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
const IntegrationsPane = () =>
  import(/* webpackChunkName: "Account" */ 'src/components/Dashboard/Views/Company/CompanyIntegrations.vue');

const AgencySettingsPane = () =>
  import(/* webpackChunkName: "Account" */ 'src/components/Dashboard/Views/Company/AgencySettings.vue');

const DigestSettingsPane = () =>
  import(/* webpackChunkName: "Account" */ 'src/components/Dashboard/Views/Company/DigestSettings.vue');

export const companyRoutes = [
  
  {
    path: 'profile/integrations/:integrationType?',
    name: 'Integrations',
    component: IntegrationsPane,
    // props: route => ({ integrationType: route.query.followup === 'true' })
  },
  {
    path: 'profile/agency',
    name: 'Agency Settings',
    component: AgencySettingsPane
  },
  {
    path: 'profile/digests',
    name: 'Digest Settings',
    component: DigestSettingsPane
  }
];
